export default "__VITE_ASSET__0d5a3b73__"